import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import ViewScoreSectional from '../components/MT_Score/ViewScoreSectional'

const MtScoreViewScoreSectional = () => {
  return (
    <>
    <Navbar />
    <ViewScoreSectional />
    </>
  )
}

export default MtScoreViewScoreSectional